import type { HeavenlyStem } from '../types/stems';
import type { EarthlyBranch } from '../types/branches';
import type { Eumyang } from '../types/elements';
import { HEAVENLY_STEMS, EARTHLY_BRANCHES } from './constants';

/** 천간의 음양을 반환한다. 짝수 인덱스 = 양, 홀수 인덱스 = 음 */
export function getStemEumyang(stem: HeavenlyStem): Eumyang {
  const idx = HEAVENLY_STEMS.indexOf(stem);
  return idx % 2 === 0 ? '양' : '음';
}

/** 지지의 음양을 반환한다. 짝수 인덱스 = 양, 홀수 인덱스 = 음 */
export function getBranchEumyang(branch: EarthlyBranch): Eumyang {
  const idx = EARTHLY_BRANCHES.indexOf(branch);
  return idx % 2 === 0 ? '양' : '음';
}

/** 천간이 양간인지 확인한다 */
export function isStemYang(stem: HeavenlyStem): boolean {
  return getStemEumyang(stem) === '양';
}
